<template>
  <WishlistButton
    :disabled="isDisabled"
    :product-group-identifier="productGroupIdentifier"
    :sku="currentSku"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import WishlistButton from '@/components/MyHobbii/views/MyWishlist/WishlistButton.vue';
import { useProductStore } from '@/shared/pinia/modules/product';
import { useProductOptionsStore } from '@/shared/pinia/modules/product-options';
import { getProductDataFromHTML } from '@/shared/utils/product';

const optionsStore = useProductOptionsStore();
const productStore = useProductStore();

// Patterns render no options picker, so the options store never gets their SKU
const currentSku = computed<string | undefined>(() =>
  productStore.isPattern
    ? getProductDataFromHTML().productSku || undefined
    : (optionsStore.activeOption?.sku as string | undefined)
);

const productGroupIdentifier = computed(
  () => productStore.productGroupId ?? undefined
);

const isDisabled = computed(
  () => !currentSku.value && !productGroupIdentifier.value
);
</script>
